import { createSlice } from "@reduxjs/toolkit";

// initial state of slice
const initialState = {
    employeeBeacons: [],
};



// slice declaration
const employeeBeaconsSlice = createSlice({
    name: "employeeBeacons",
    initialState,
    reducers: {
        reset: (state) => initialState,
        setEmployeeBeacons: (state, action) => {
            state.employeeBeacons = action.payload;
        },
    }
});

export const { reset, setEmployeeBeacons } = employeeBeaconsSlice.actions;
export const selectEmployeeBeacons = (state) => state.employeeBeacons.employeeBeacons;
export const selectEmployeeBeaconById = (state, employeeId) => {
    return state.employeeBeacons.employeeBeacons.find(beacon => beacon.employeeId === employeeId) || null;
};
export default employeeBeaconsSlice.reducer;